class UtilsCommon {

  /**
   * Check if the token exists in the local storage. It's the indicator of the user being logged in.
   * @returns {boolean}
   */
  static authTokenExists() {
    return !!localStorage.getItem('token');
  }
}

export default UtilsCommon;